import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { Deposito } from 'src/app/funds/public/_models/deposito';
import { DepositosService } from 'src/app/funds/public/_services/depositos.service';

@Component({
  selector: 'app-banner-funds-depositos',
  templateUrl: './banner-funds-depositos.component.html',
  styleUrls: ['./banner-funds-depositos.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    BtnLinkComponent
  ]
})

export class BannerFundsDepositosComponent 
{

  @Input() domainUrl: string;
  @Input() plataformaId: string;
  isLoading: boolean = false;
  datosDeposito: Deposito = new Deposito();

  constructor(
    private _depositosService: DepositosService,
  ) 
  {

  }

  ngOnInit(): void{
   
    this.getDatosDeposito();
  }

  getDatosDeposito()
  {
    this.isLoading = true;
    this._depositosService.getDatosDeposito().subscribe({
      next: r =>
      {
        this.isLoading = false;
        this.datosDeposito = r;
      },
      error: e =>
      {
        this.isLoading = false;
        // Quitado para evitar multiples snackbars en home si falla webcontent
        // this._matSnackBar.open(this._depositosService.getServerErrors(e), 'x', new SnackBarErrorConfig());
      }
    })
  }
}
